export default __webpack_public_path__ + "static/media/60.b4136e13.jpg";